module.exports = __webpack_public_path__ + "img/贡献4.90b0871f.png";